import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import { Question } from 'components/Question'
import { Explainer } from 'components/Explainer'
import { CallBox } from 'components/Callbox'
import quizzesData from 'quizzes.json'

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  properties = properties || {
    questionID: 'cows',
  }
  const questionID = properties?.questionID
  return (
    <AppContainer className={globalClasses.join(' ')}>
      {questionID !== 'explain' && questionID !== 'callbox' && (
        <Question questionID={questionID} quizzesData={quizzesData} />
      )}
      {questionID === 'explain' && <Explainer />}
      {questionID === 'callbox' && <CallBox />}
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  width: 100%;
  margin: 0;
  padding: 0;
  font-family: var(--font-sans-serif);
  font-size: 16px;
  color: var(--brandblue-main);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--site-background);
`
export default MainComponent
